import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { useCustomAuth } from "@/contexts/CustomAuthContext";

const NotFound = () => {
  useLanguage();
  const location = useLocation();
  const { isAuthenticated, isLoading } = useCustomAuth();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  // Enquanto verifica autenticação, não faz nada
  if (isLoading) {
    return null;
  }

  // Usuário não autenticado (ex: cache limpo) → redireciona para login
  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-4">{translateInterfaceText("Oops! Page not found")}</p>
        <a href="/" className="text-blue-500 hover:text-blue-700 underline">
          {translateInterfaceText("Return to Home")}</a>
      </div>
    </div>
  );
};

export default NotFound;
